
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import {
  rgbToHex,
  hexToRgb
} from "@/components/Reusable/CustomInputs/3rdPartyWrappers/Gradient/helpers";
import GradientInput from "@/components/Reusable/CustomInputs/3rdPartyWrappers/Gradient/GradientInput.vue";

@Component({
  components: {
    GradientInput
  }
})
export default class Preview extends Vue {
  @Prop()
  red!: number;

  @Prop()
  green!: number;

  @Prop()
  blue!: number;

  @Prop()
  alpha!: number;

  @Prop()
  updateColor!: Function;

  inProgress = false;
  hexValue = rgbToHex(this.red, this.green, this.blue);

  get hex() {
    return rgbToHex(this.red, this.green, this.blue);
  }

  @Watch("inProgress")
  onProgressChange() {
    this.setHex();
  }

  @Watch("red")
  onRedChange() {
    this.setHex();
  }

  @Watch("green")
  onGreenChange() {
    this.setHex();
  }

  @Watch("blue")
  onBlueChange() {
    this.setHex();
  }

  setHex() {
    if (this.inProgress) {
      return;
    }

    this.hexValue = this.hex;
  }

  changeHex(event: Event) {
    const target = event.target as HTMLInputElement;
    const color = hexToRgb(target.value);

    if (color) {
      this.updateColor(color);
    }
  }
}
